/* eslint-disable no-param-reassign */
import CryptoJS from 'crypto-js';

export default {
  hash(file, valueLocal) {
    valueLocal.hashProgress = 0;
    valueLocal.hashStopNow = false;

    return new Promise((resolve, reject) => {
      const blobSlice = File.prototype.slice
        || File.prototype.mozSlice || File.prototype.webkitSlice;
      const chunkSize = 1097152;
      const chunks = Math.ceil(file.size / chunkSize);
      let currentChunk = 0;
      const sha256 = CryptoJS.algo.SHA256.create();
      const fileReader = new FileReader();

      function loadNext() {
        const start = currentChunk * chunkSize;
        const end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize;
        fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
      }

      fileReader.onload = (e) => {
        if (valueLocal.hashStopNow) {
          valueLocal.hashStopNow = false;
          valueLocal.hashProgress = 0;
          reject(new Error('Обработка прервана'));
          return;
        }

        const chunk = e.target.result;
        const chunkUint8 = new Uint8Array(chunk);
        const wordArr = CryptoJS.lib.WordArray.create(chunkUint8);
        sha256.update(wordArr);
        currentChunk += 1;

        valueLocal.hashProgress = parseInt((currentChunk / chunks) * 100, 10);

        if (currentChunk < chunks) {
          loadNext();
        } else {
          const hash = sha256.finalize().toString(CryptoJS.enc.Base64);
          valueLocal.hashProgress = 0;
          resolve(hash);
        }
      };

      loadNext();
    });
  },
};



// WEBPACK FOOTER //
// ./src/helpers/sha256.js